/** Stateless bridge: commit lanes never import the beacon's tab-local state. */
export function observeLocalTruthCommit(lane: string, command: unknown, outcome: 'sending' | 'accepted' | 'refused' | 'stale' | 'failed' | 'unknown', reason?: unknown): void {
    try {
        if (typeof window !== 'undefined') (window as Window & {
            ftObserveTruthCommit?: (lane: string, command: unknown, outcome: string, reason?: unknown) => void;
        }).ftObserveTruthCommit?.(lane, command, outcome, reason);
    } catch { /* Diagnostics must not change delivery or reconciliation. */ }
}
/** Retain pre-plan intent too: a refusal may never reach a truth outbox. No copies on this path. */
export function observeTruthIntent(lane: string, command: unknown): void {
    try {
        (window as Window & { ftObserveTruthIntent?: (lane: string, command: unknown) => void })
            .ftObserveTruthIntent?.(lane, command);
    } catch { /* Telemetry cannot change a decision. */ }
}
